export const RELATED_PERSON_CHOICES = [
  { id: 'ADMIN', name: 'Admin' },
  { id: 'SPOUSE', name: 'Spouse' },
  { id: 'CHILD', name: 'Child' },
  { id: 'ASSISTANT', name: 'Assistant' },
  { id: 'PARTNER', name: 'Partner' },
  { id: 'OTHER', name: 'Other' }
];
